import React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import { getAhrBaseBreadcrumbs } from "src/Pages/AhrCore/routerHelper";
import __ from "src/utils/Translations";
import Archive from "src/Pages/Report/GeneratedReports/List";

export default () => {
  const companyName = useCompanyName();
  const companyId = useCompanyId();

  const archiveDetailsUrl = (id) => `/ahr/report/archive/details/${id}`;

  return (
    <>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <PageTitle
          heading={`Archiwum raportów dla firmy ${companyName} (ID: ${companyId})`}
          breadcrumbsHeading={__("Archiwum")}
          pushToHistory
          breadcrumbs={[
            ...getAhrBaseBreadcrumbs(companyName),
            { title: __("Raporty"), link: "/ahr/report" },
          ]}
        />
        <Archive companyId={companyId} archiveDetailsUrl={archiveDetailsUrl} />
      </CSSTransitionGroup>
    </>
  );
};
